(function(angular, _) {
    /**
     * @ngdoc service
     * @name PathEdgeFactory
     * @description Represents the path graph edge connecting two vertices
     */
    class PathEdgeFactory {
        constructor(vertexA, vertexB, value = null, meta = {}) {
            this.uuid = _.uniqueId('edge');
            this.value = value;
            this.meta = meta;

            this.tailVertex = vertexA;
            this.headVertex = vertexB;
        }

        get vertices() {
            return [this.tailVertex, this.headVertex];
        }

        get tail() {
            return this.tailVertex;
        }

        get head() {
            return this.headVertex;
        }

        setValue(value) {
            this.value = value;

            return this;
        }

        getValue() {
            return this.value;
        }

        getMeta(path = null) {
            if (path) {
                return _.get(this.meta, path, null);
            }

            return this.meta;
        }

        setMeta(meta, value) {
            if (_.isPlainObject(meta)) {
                this.meta = meta;
            } else if (_.isUndefined(value)) {
                delete this.meta[meta];
            } else if (_.isString(meta)) {
                _.set(this.meta, meta, value);
            }

            return this;
        }

        toJSON() {
            return _.chain(this)
                .pick(['uuid', 'value', 'meta'])
                .cloneDeep()
                .assign({
                    vertices: [this.tail.uuid, this.head.uuid]
                })
                .value();
        }

        destroy() {
            this.tailVertex = null;
            this.headVertex = null;
            this.uuid = null;
            this.value = null;
            this.meta = null;
        }
    }

    angular.module('wtApp.dataService')
        .factory('PathEdgeFactory', () => PathEdgeFactory);
})(window.angular, window._);
